//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";

export default {
    name: "QfPGetSet",
    props: {
        getLabel: { type: String, default: "Get data" },
        setLabel: { type: String, default: "Set data" }
    },
    data() {
        return {
            fromRemote: false
        };
    },
    computed: {
        ...mapState("components", ["properties", "activeComponent"]),
        localProperties() {
            return this.properties[this.activeComponent];
        },
        mapLink: {
            get() {
                return this.localProperties.__generics.mapLink;
            },
            set(value) {
                this.localProperties.__generics.mapLink = value;
            }
        }
    },
    watch: {
        mapLink(val) {
            if (val) {
                if (this.localProperties.get) {
                    if (!this.localProperties.set) {
                        this.localProperties.set = this.localProperties.get;
                    }
                } else if (this.localProperties.set) {
                    this.localProperties.get = this.localProperties.set;
                }
            }
        },
        "localProperties.get": {
            handler(val) {
                if (this.mapLink) {
                    this.localProperties.set = val;
                }
            }
        },
        "localProperties.set": {
            handler(val) {
                if (this.mapLink) {
                    this.localProperties.get = val;
                }
            }
        }
    }
};
